import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';
import '../styles/Footer.css';

const Footer = ({ data }) => {
  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">BB</div>
          <p className="footer-text">
            AI Engineer passionate about building intelligent systems with real-world impact.
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Quick Links</h4>
          <nav className="footer-links">
            <a href="#home" className="footer-link">About</a>
            <a href="#skills" className="footer-link">Skills</a>
            <a href="#projects" className="footer-link">Projects</a>
            <a href="#contact" className="footer-link">Contact</a>
          </nav>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Connect</h4>
          <div className="footer-socials">
            <a href={data.github} target="_blank" rel="noopener noreferrer" className="social-link">
              <Github className="h-5 w-5" />
            </a>
            <a href={data.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
              <Linkedin className="h-5 w-5" />
            </a>
            <a href={`mailto:${data.email}`} className="social-link">
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {new Date().getFullYear()} {data.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;